// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"0277d3ce","703":"ed4ead64"}[chunkId] + ".chunk.js";
};